import React, { Suspense } from "react";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";

type SkeletonLayout = "default" | "page" | "form" | "cards";
export const SUSPENSE_WRAPPER = (
  component: React.ReactNode,
  layout?: SkeletonLayout,
  height?: number | string,
  lines?: number
) => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "200px",
            width: "100%",
          }}
        >
          <div style={{ width: "100%", maxWidth: "800px" }}>
            <SkeletonLoader
              layout={layout}
              variant="rectangular"
              lines={lines || 5}
              height={height || 30}
            />
          </div>
        </div>
      }
    >
      {component}
    </Suspense>
  );
};
